module.exports = { PENDING: 'pending', RESOLVED: 'resolved' };
